import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AppConfigsService } from 'ClientApp/app/config/app-configs.service';
import { HokHeaderItem } from 'ClientApp/app/modules/direct-debit/interfaces/IGetHokDetailsForAllCard.interface';
import { Subscription } from 'rxjs/Subscription';
import { ModalService } from '../../../../../../shared/modules/bs-modal/services/modal.service';
import { CHBEventId, ICancelDirectDebitRequest, ICheckCBKRequest } from '../../interfaces/cancel.interface';
import { IContentResponse } from '../../../../interfaces/IContentResponse.interface';
import { DirectDebitService } from '../../../../services/direct-debit.service';
import { EHokStatus } from '../../interfaces/filters.interface';
import { DebitListService } from '../../services/main-debit-list.service';
import { GtmService } from 'ClientApp/app/shared/cardholders-core/services/gtm.service';
import { UiHelperService } from 'ClientApp/app/shared/cardholders-core/services/ui-helper.service';

@Component({
    selector: 'app-main-list-popup',
    templateUrl: './main-list-popup.component.html',
    styleUrls: ['./main-list-popup.component.scss']
})
export class MainListPopupComponent implements OnInit, OnDestroy {
    @Input()
    hok: HokHeaderItem;
    status: string;
    showLoader = false;
    rcCancel = 0;
    cbkId = 0;
    redirectToOld = true;
    subs: Subscription[] = [];
    contents: IContentResponse;
    constructor(
        private modalSrv: ModalService,
        private debListSrv: DebitListService,
        private directDebitSrv: DirectDebitService,
        private config: AppConfigsService,
        private uiHelperSrv: UiHelperService,
        private gtmService: GtmService
    ) {}
    ngOnDestroy(): void {
        this.subs.forEach((s) => s.unsubscribe());
    }

    ngOnInit(): void {
        this.gtmService.pushDirectDebitList('Popup more details', 'show');
        this.status = this.getStatusName();
        this.subs.push(this.directDebitSrv.contents$.subscribe((contents) => (this.contents = contents)));
        if (!this.directDebitSrv.contents$.getValue()) {
            this.debListSrv.getHokDetailsForAllCard({ ActiveIndicator: 1 }).subscribe((res) => {
                switch (res.returnCode) {
                    case 0:
                        this.directDebitSrv.contents$.next(res.result.content);
                        break;

                    default:
                        break;
                }
            });
        }
    }
    getStatusName(): string {
        if (this.hok.messageStatus === '1' || this.hok.messageStatus === '2') {
            return 'הועבר לבית העסק להמשך טיפול';
        }
        if (this.hok.status === 2) {
            this.gtmService.pushDirectDebitList('Release  DirectDebit', 'show');
            return this.debListSrv.getStatusName(EHokStatus.Canceled);
        }
        if (this.hok.status === 1) {
            this.gtmService.pushDirectDebitList('Cancel DirectDebit', 'show');
            return this.debListSrv.getStatusName(EHokStatus.Active);
        }
        if (this.hok.status === 0) {
            return this.debListSrv.getStatusName(EHokStatus.Off);
        }
    }
    clickPhone(merchantPhone: string): void {
        if (this.uiHelperSrv.IsMobile()) {
            window.open(`tel:${merchantPhone}`, `_blank`);
        }
    }
    close(): void {
        this.modalSrv.closeModalAndAlertSubscribers();
    }
    get planName(): string {
        try {
            return this.hok.hokHistoryDetails.hokTransDetailsList[0].planName;
        } catch (error) {
            return '';
        }
    }
    get address(): string {
        let address = '';
        if (this.hok.merchantAddress) {
            address += `${this.hok.merchantAddress}, `;
        }
        if (this.hok.merchantCity) {
            address += `${this.hok.merchantCity}, `;
        }
        if (this.hok.merchantZip) {
            address += `${this.hok.merchantZip} `;
        }

        return address;
    }
    get txnMethod(): string {
        try {
            switch (this.hok.hokHistoryDetails.hokTransDetailsList[0].txnMethod) {
                case '1':
                    return 'אחר';
                case '2':
                    return 'בנוכחות כרטיס';
                case '3':
                    return 'טלפוני';
                case '4':
                    return 'אינטרנט';

                default:
                    return '';
            }
        } catch (error) {
            return '';
        }
    }
    next(type: string): void {
        switch (type) {
            case 'release':
                this.releaseDirectDebit();
                break;
            case 'cancel':
                this.cancelDirectDebit();
                break;

            default:
                break;
        }
    }
    releaseDirectDebit(): void {
        this.gtmService.pushDirectDebitList('Release DirectDebit', 'show');
        this.modalSrv.closeModalAndAlertSubscribers('release');
    }
    cancelDirectDebit(): void {
        this.gtmService.pushDirectDebitList('Cancel DirectDebit', 'click');
        if (this.redirectToOld) {
            this.directDebitSrv.loader = true;
            const request: ICheckCBKRequest = {
                MerchantNumber: this.hok.merchantID
            };
            this.subs.push(
                this.debListSrv.checkCBK(request).subscribe((x) => {
                    switch (x.returnCode) {
                        case 0:
                            this.modalSrv.closeModalAndAlertSubscribers('cancel');

                            let pageUrl: string;
                            if (!this.config.appConfigs.FLAG_ISRedirectToNewCancelDirectDebitPage) {
                                pageUrl =
                                    this.config.appConfigs.infoRoot +
                                    '/Registred/Transactions/CancelDirectDebit.aspx?CardIndex=';
                            } else {
                                pageUrl =
                                    this.config.appConfigs.baseUiRoot +
                                    '/cancel-permanent-order/personal/main?CardIndex=';
                            }
                            const href =
                                pageUrl +
                                this.hok.cardIndex +
                                '&PostingDate=' +
                                this.hok.processingDate +
                                '&ACQ=' +
                                this.hok.merchantAcquirer +
                                '&MerchantNumber=' +
                                this.hok.merchantID;
                            window.location.href = href;
                            break;
                        case 10:
                            this.rcCancel = x.returnCode;
                            this.cbkId = x.result.cbkId;
                            this.directDebitSrv.loader = false;
                            break;

                        default:
                            this.rcCancel = x.returnCode;
                            this.directDebitSrv.loader = false;
                            break;
                    }
                })
            );

            return;
        }
        const req: ICancelDirectDebitRequest = {
            merchantNumber: this.hok.merchantID,
            acq: this.hok.merchantAcquirer,
            cardIndex: this.hok.cardIndex,
            futureTransInd: CHBEventId.CancelDirectDebit,
            postingDate: this.hok.processingDate
        };
        this.directDebitSrv.loader = true;
        this.subs.push(
            this.debListSrv.cancelDirectDebit(req).subscribe((x) => {
                this.directDebitSrv.loader = false;

                switch (x.returnCode) {
                    case 0:
                        break;

                    default:
                        break;
                }
            })
        );
    }
}
